<template>
  <div class="home">
    <Teams/>
  </div>
</template>

<script>
// @ is an alias to /src
import Teams from '@/components/Teams.vue'
import getTeamsMixin from '@/data/get-teams-mixin.js'
import { mapActions } from 'vuex'

export default {
  name: 'teams',
  mixins: [getTeamsMixin],
  components: {
    Teams
  },
  created() {
    // Ensure data is loaded when this view is created
    this.ensureDataLoaded()
  },
  methods: {
    ...mapActions('teamData', ['initializeYearFromStorage']),
    async ensureDataLoaded() {
      // Check if we have data, if not, initialize it
      if (!this.teamData || Object.keys(this.teamData).length === 0) {
        await this.initializeYearFromStorage()
      }
    }
  }
}
</script>
